import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  service_type: "from_airport",
  pickup: {
    address: "Boston Logan International Airport",
    coordinates: { lat: 42.3656338, lng: -71.0282381 }
  },
  dropoff: "",
  duration: null,
  coverage: null,
  date: null,
  time: null,
  passenger: null,
  luggage: null,
  regular: null,
  infant: null,
  fleet_id: null,
  fleet_record_with_rate_id: null,
  maps_record_id: null,
  selected_vehicle_id: null,
  booking_info_record_id: null,
  fleet_selection: null,
  card: null,
  booking_info: null,
  booking_id: null,
  domain_id: null,
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setPickup: (state, action) => {
      state.pickup = action.payload;
    },
    setDropoff: (state, action) => {
      state.dropoff = action.payload;
    },
    setDistance: (state, action) => {
      state.distance = action.payload;
    },
    setDuration: (state, action) => {
      state.duration = action.payload;
    },
    setCoverage: (state, action) => {
      state.coverage = action.payload;
    },
    setServiceType: (state, action) => {
      state.service_type = action.payload;
    },
    setPassenger: (state, action) => {
      state.passenger = action.payload;
    },
    setLuggage: (state, action) => {
      state.luggage = action.payload;
    },
    setBooster: (state, action) => {
      state.booster = action.payload;
    },
    setRegular: (state, action) => {
      state.regular = action.payload;
    },
    setInfant: (state, action) => {
      state.infant = action.payload;
    },
    setDate: (state, action) => {
      state.date = action.payload;
    },
    setTime: (state, action) => {
      state.time = action.payload;
    },
    selectFleet: (state, action) => {
      state.fleet_id = action.payload;
    },
    setSelectedVehicleId: (state, action) => {
      state.selected_vehicle_id = action.payload;
    },
    setFleetRecordWithRateId: (state, action) => {
      state.fleet_record_with_rate_id = action.payload;
    },
    setMapsRecordId: (state, action) => {
      state.maps_record_id = action.payload;
    },
    setQuoteInfoRecordId: (state, action) => {
      state.quote_info_record_id = action.payload;
    },
    setBookingInfoRecordId: (state, action) => {
      state.booking_info_record_id = action.payload;
    },
    setFleetSelection: (state, action) => {
      state.fleet_selection = action.payload;
    },
    addCard: (state, action) => {
      state.card = action.payload;
    },
    addBookingInfo: (state, action) => {
      state.booking_info = action.payload;
    },
    removeCard: (state) => {
      state.card = null;
    },
    setBookingId: (state, action) => {
      state.booking_id = action.payload;
    },
    setDomainId: (state, action) => {
      state.domain_id = action.payload;
    },
    resetBooking: () => initialState,
  },
});

export const {
  setPickup,
  setDropoff,
  setDistance,
  setDuration,
  setCoverage,
  setServiceType,
  setPassenger,
  setLuggage,
  setBooster,
  setRegular,
  setInfant,
  setDate,
  setTime,
  selectFleet,
  setSelectedVehicleId,
  setFleetRecordWithRateId,
  setMapsRecordId,
  setQuoteInfoRecordId,
  setBookingInfoRecordId,
  setFleetSelection,
  addCard,
  addBookingInfo,
  removeCard,
  setBookingId,
  setDomainId,
  resetBooking,
} = bookingSlice.actions;

export default bookingSlice.reducer;
